module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("aRAGl"))).then(() => parcelRequire('d0iPb'));